export const Tags = Object.freeze({
  /**
   * This is the primary location/client or group for this contact
   */
  PRIMARY: 'primary',
  /**
   * This contact will be notified of any bookings at this location/client or group
   * (aka confirmed contact)
   */
  CONFIRMED: 'confirmed',
  /**
   * Signifies that the replace me feature is enabled at this location/client or group
   */
  REPLACE_ME_ENABLED: 'replace_me_feature_enabled',
})
